import ApplicationController from './application_controller'
import $ from 'jquery'

export default class extends ApplicationController

  # Show file dialog
  showDialog: (event) ->
    $('dialog').get(0).showModal()
    event.preventDefault()

  # Load transaction files
  close: (event) -> $('dialog').get(0).close()
